import React, { useContext } from 'react'
import { ContentFooter } from '../../layout/Content'
import RecordNavigator from '../../layout/RecordNavigator'
import StockInListFooterStyle from './css/StockInListFooterStyle'
import { stockInListControllerContext } from './StockInListController'

function StockInListFooter() {
  const stockInListController = useContext(stockInListControllerContext)
  const { getTotalRecords, totalPage, warehouses } = stockInListController
  const [recordPerPage, setRecordPerPage] = stockInListController.recordPerPage
  const [recPP, setRecPP] = stockInListController.recPP
  const [page, setPage] = stockInListController.page
  const [warehouse, setWarehouse] = stockInListController.warehouse

  const recordNavigatorProps = {
    recPP: [recPP, setRecPP],
    page: [page, setPage],
    recordPerPage: [recordPerPage, setRecordPerPage],
    totalPage, getTotalRecords
  }

  const onChange = (e) => {
    let warehouse_id = (warehouses.find(wh => wh.name === e.target.value)._id)
    if (!warehouse_id) warehouse_id = 0
     setWarehouse({
      ...warehouse,
      name: e.target.value,
      _id: warehouse_id
    })
  }

  return (
    <ContentFooter>
      <div id="stockin-list-footer-container">
        <div className='warehouse-options-container'>
          <select
            onChange={onChange}
            value={(warehouse) ? warehouse.name : ''}>
            {
              (warehouses) ?
                warehouses.map(wh => (
                  <option key={wh._id}>{wh.name}</option>
                ))
              : null
            }
          </select>
        </div>
        <RecordNavigator { ...recordNavigatorProps } />
      </div>
      <StockInListFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(StockInListFooter)
